import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-home',
  imports: [],
  templateUrl: './icon-home.component.html',
  styleUrl: './icon-home.component.scss',
})
export class IconHomeComponent {
  @Input() color: string = '#fff';
  @Input() size: string = '24px';
}
